module.exports = __webpack_public_path__ + "static/images/banner-close.2EO6xLY.svg";